import React, {useEffect, useState} from 'react';
import {Controller} from "react-hook-form";
import {
		Box,
		Button,
		Card,
		CardContent,
		CardHeader,
		Divider,
		Grid,
		TextField
} from '@material-ui/core';
import ParkingZoneRepository from "../../../repositories/ParkingZoneRepository";
import CameraRepository from "../../../repositories/CameraRepository";
import CameraSetRepository from "../../../repositories/CameraSetRepository";
import {useNavigate, useParams} from "react-router";
import FormLoading from "../../../components/FormLoading";
import {useCrudForm} from "../../../hooks/crud/Form";
import {useTranslation} from "react-i18next";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Input from "@material-ui/core/Input";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import {unregister} from "../../../serviceWorker";

const Form = () => {
	const navigate = useNavigate();
	const {t} = useTranslation();

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };

	const {id} = useParams();
	const repository = new CameraSetRepository();
	const [cameras, setCameras] = useState([]);
	const [selectedCameras, setSelectedCameras] = useState([]);
	const [parkingZones, setParkingZones] = useState([]);
	const { form, onSubmit, isSubmitting, hasError, errorMessage } = useCrudForm(repository, {
            id: id,
            onSuccess: () => navigate("/app/camera-sets"),
            onLoad: (data) => {
                if (data) {
                    setSelectedCameras(data.Cameras);
                }
            }
        }

        );
	const { control, register, setValue, watch } = form;

    let parkingZoneId = watch('ParkingZoneId');

    useEffect(async () => {

        const parkingZoneRepository = new ParkingZoneRepository();

        const result2 = await parkingZoneRepository.getSelector();
        setParkingZones(result2.data);

        register('Cameras', { });

        return () => {
            unregister('Cameras');
        }
    }, [id]);

    useEffect(async () => {
        if (parkingZoneId) {
            const cameraRepository = new CameraRepository();
            const result = await cameraRepository.getSelector(parkingZoneId);
            setCameras(result.data);
        }

        return () => {};
    }, [parkingZoneId]);

    const camerasSelectHandler = ({target}) => {

        setSelectedCameras(target.value);
        setValue('Cameras', target.value);
    }

    return (
			<form onSubmit={onSubmit}
			>
                 <Grid item xs={12} lg={8}>
                     {isSubmitting && <FormLoading />}
                     <Card>
                        <CardHeader title={t('Information')} />
                        <Divider />
                        <CardContent>
                              <Controller
                                    as={TextField} control={control}
                                    fullWidth
                                    error={hasError('ParkingZoneId')}
                                    label={t('Parking zone')}
                                    name="ParkingZoneId"
                                    helperText={errorMessage('ParkingZoneId')}
                                    select
                                    SelectProps={{ native: true }}
                                    defaultValue={""}
                                    variant="outlined"
                              >
                                  <option></option>
                                {parkingZones.map((item) => (
                                  <option
                                    key={item.Id}
                                    value={item.Id}
                                  >
                                    {item.Name}
                                  </option>
                                ))}
                              </Controller>

                        </CardContent>
                     </Card>
                     <Box mt={3}>
                         <Card>
                             <CardHeader title={t('Cameras')} />
                             <Divider />
                             <CardContent>
                                <Select
                                      multiple
                                      fullWidth
                                      displayEmpty
                                      value={selectedCameras}
                                      input={<Input />}
                                      renderValue={(selected) => {
                                        return cameras.filter(x => selected.includes(x.Id)).map(x => x.Name).join(', ');
                                      }}
                                      MenuProps={MenuProps}
                                      onChange={camerasSelectHandler}
                                    >
                                      {cameras.map((item) => (
                                        <MenuItem key={item.Id} value={item.Id}>
                                            <Checkbox checked={selectedCameras.filter(x => x == item.Id).length > 0} />
                                            <ListItemText primary={item.Name} />
                                        </MenuItem>
                                      ))}
                                    </Select>

                             </CardContent>
                         </Card>
                     </Box>`
                     </Grid>
                     <Box mt={2}>

                         <Button
                            color="secondary"
                            variant="contained"
                            type="submit"
                            name="submit"
                            disabled={isSubmitting}
                        >
                            {t('Save')}
                        </Button>
                     </Box>
                </form>
	);
};

export default Form;